import {
  dbReducer,
  insert,
  ReduxFind,
  removeMany,
  removeOne,
  updateOne,
} from '@weblite/persist'
import { PendingUpload } from '$logic/pending-uploads/types'

const COLLECTION = 'pendingUploads'

export const pendingUploadsStorage = {
  delete(uploadId: string) {
    removeOne(COLLECTION)(uploadId)
  },

  deleteMany(uploadIds: string[]) {
    removeMany(COLLECTION)(uploadIds)
  },
  get(uploadId: string): PendingUpload {
    return ReduxFind(COLLECTION, { uploadId })[0]
  },

  getAll(): PendingUpload[] {
    return ReduxFind(COLLECTION, {})
  },

  insert(message: PendingUpload) {
    insert(COLLECTION)([message])
  },

  update(message: PendingUpload) {
    return updateOne(COLLECTION)(message.uploadId, { $set: message })
  },
}

export const pendingUploadsReducer = dbReducer(['main', COLLECTION])
